import React, { useState } from 'react'
import useTrans from '../../../hooks/useTrans'
import Chip from '../../atoms/Chip/Chip'
import { ChevronDown, ChevronUp, Filter } from '../../atoms/NewIcons'

const SearchNav = ({ openFilters, children }) => {
  const t = useTrans()
  const [openMenu, setOpenMenu] = useState(false)
  return (
    <div className="search-nav">
      <div className="search-nav__content">
        <div className="search-nav__trigger" onClick={() => setOpenMenu(!openMenu)}>
          {t('Suggerimenti')}
          {openMenu ? (
            <ChevronUp classes="search-nav__arrow-icon" />
          ) : (
            <ChevronDown classes="search-nav__arrow-icon" />
          )}
        </div>
        <Chip
          placeholder={t('Filtri')}
          size="md"
          icon={<Filter />}
          iconPos="left"
          onClick={openFilters}
        />
      </div>
      <div className={'search-nav__children' + (openMenu ? ' search-nav__children--open' : '')}>
        {children}
      </div>
    </div>
  )
}

export default SearchNav
